module.exports = __webpack_public_path__ + "img/B202.78a1cbbb.png";